<template>
    <div :class="['bl-action-widget', { 'full-width': expanded }]">
        <div
            v-if="!expanded"
            class="widget-state closed"
            @click="toggleExpanded(true)"
        >
            <span class="icon material-symbols-outlined">settings</span>
        </div>
        <div v-if="expanded" class="widget-state expanded">
            <ul>
                <li :class="{ active: sorting }" @click="onClickSorting()">
                    <span class="icon-toggle material-symbols-outlined">
                        {{ getToggleIcon(sorting) }}
                    </span>
                    Sort
                </li>
                <li :class="{ active: deleting }" @click="onClickDeleting()">
                    <span class="icon-toggle material-symbols-outlined">
                        {{ getToggleIcon(deleting) }}
                    </span>
                    Delete
                </li>
                <li @click="onClickClosing()">Close</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: "BLActionWidget",
    emits: ["deleting", "sorting", "closing", "expanded"],
    data() {
        return {
            expanded: false,
            deleting: false,
            sorting: false,
        };
    },
    methods: {
        onClickSorting() {
            this.sorting = !this.sorting;
            this.deleting = false;
            this.$emit(this.sorting ? "sorting" : "closing");
        },
        onClickDeleting() {
            this.sorting = false;
            this.deleting = !this.deleting;
            this.$emit(this.deleting ? "deleting" : "closing");
        },
        onClickClosing() {
            this.sorting = false;
            this.deleting = false;
            this.$emit("closing");
            this.toggleExpanded(false);
        },
        toggleExpanded(isExpanded) {
            this.expanded = isExpanded;
            this.$emit("expanded", this.expanded);
        },
        getToggleIcon(action) {
            return action ? "toggle_on" : "toggle_off";
        },
    },
};
</script>
